var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !this.$store.state.onMobileTablet
    ? _c(
        "nav",
        {
          staticClass: "sidebar-wrapper sidebar-wrapper-mini",
          attrs: { id: "sidebar" }
        },
        [
          _c("div", { staticClass: "sidebar-content" }, [
            _c("div", { staticClass: "sidebar-header" }, [
              _c("div", { staticClass: "profile-wrap" }, [
                _c("div", { staticClass: "user-pic" }, [
                  this.$store.state.user.profileImage
                    ? _c("img", {
                        staticClass: "img-responsive img-rounded",
                        attrs: {
                          src: this.$store.state.user.profileImage,
                          alt: "User picture"
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  !this.$store.state.user.profileImage
                    ? _c("img", {
                        staticClass: "img-responsive img-rounded",
                        attrs: {
                          src: require("../../assets/user.jpg"),
                          alt: "User picture"
                        }
                      })
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "user-info" }, [
                  _c("span", { staticClass: "user-name" }, [
                    _vm._v(_vm._s(_vm.name))
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "user-role" }, [
                    _vm._v(_vm._s(_vm.organization))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "cursor-pointer signout-link notForMobile",
                  on: { click: _vm.userSignOut }
                },
                [_c("i", { staticClass: "fas fa-sign-out-alt" })]
              )
            ]),
            _vm._v(" "),
            this.$store.state.onMobileTablet
              ? _c("div", { staticClass: "toggle-button-cover" }, [
                  _c("div", { staticClass: "button-cover" }, [
                    _c(
                      "div",
                      {
                        staticClass: "button r",
                        attrs: { id: "sideBarSwitch" }
                      },
                      [
                        _c("input", {
                          staticClass: "checkbox",
                          attrs: { id: "switch", type: "checkbox" },
                          on: { click: _vm.openSideBar }
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "knobs" }),
                        _vm._v(" "),
                        _c("div", { staticClass: "layer" })
                      ]
                    )
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "navbar", attrs: { role: "navigation" } },
              [
                _c("ul", { staticClass: "navbar-nav" }, [
                  _c("li", { staticClass: "nav-item dropdown notForMobile" }, [
                    _vm._m(0),
                    _vm._v(" "),
                    _c(
                      "ul",
                      {
                        staticClass: "dropdown-menu",
                        attrs: { "aria-labelledby": "dropdowna" }
                      },
                      [
                        _c(
                          "li",
                          { staticClass: "dropdown-item dropdown" },
                          [
                            _c(
                              "router-link",
                              {
                                attrs: {
                                  to: "/newprofile/company/company-info"
                                }
                              },
                              [_vm._v(" Company ")]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "li",
                          { staticClass: "dropdown-item dropdown" },
                          [
                            _c("router-link", { attrs: { to: "/profile" } }, [
                              _vm._v(" User Info ")
                            ])
                          ],
                          1
                        )
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _vm.$store.state.user.role == "admin"
                    ? _c(
                        "li",
                        { staticClass: "nav-item notForMobile" },
                        [
                          _c(
                            "router-link",
                            { attrs: { to: "/administration" } },
                            [
                              _c("span", { staticClass: "nav-menu-icon" }, [
                                _c("img", {
                                  attrs: {
                                    src: require("../../assets/icons/settings.svg")
                                  }
                                })
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "nav-menu-text" }, [
                                _vm._v("Administration ")
                              ])
                            ]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("li", { staticClass: "nav-item dropdown" }, [
                    _vm._m(1),
                    _vm._v(" "),
                    _c(
                      "ul",
                      {
                        staticClass: "dropdown-menu",
                        attrs: { "aria-labelledby": "dropdown2" }
                      },
                      [
                        _c(
                          "li",
                          { staticClass: "dropdown-item" },
                          [
                            _c(
                              "router-link",
                              { attrs: { to: "/newprofile/add-story/step-1" } },
                              [
                                _vm._v(
                                  "\n                Add Project\n              "
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "li",
                          { staticClass: "dropdown-item" },
                          [
                            _c(
                              "router-link",
                              { attrs: { to: "/newprofile/projects" } },
                              [
                                _vm._v(
                                  "\n                Projects Gallery\n              "
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "li",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: this.$store.state.selectedStoryId.hasOwnProperty(
                                  "id"
                                ),
                                expression:
                                  "this.$store.state.selectedStoryId.hasOwnProperty('id')"
                              }
                            ],
                            staticClass: "dropdown-item dropdown"
                          },
                          [
                            _c(
                              "a",
                              {
                                staticClass: "dropdown-toggle",
                                attrs: {
                                  id: "selected-project-dropdown",
                                  "data-toggle": "dropdown",
                                  "aria-haspopup": "true",
                                  "aria-expanded": "false"
                                }
                              },
                              [
                                this.$store.state.selectedStoryId.hasOwnProperty(
                                  "title"
                                )
                                  ? [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            this.$store.state.selectedStoryId.title.substring(
                                              0,
                                              10
                                            )
                                          ) +
                                          "\n                  Dashboard\n                "
                                      )
                                    ]
                                  : _vm._e()
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c(
                              "ul",
                              {
                                staticClass: "dropdown-menu",
                                attrs: {
                                  "aria-labelledby": "selected-project-dropdown"
                                }
                              },
                              [
                                _c(
                                  "li",
                                  { staticClass: "dropdown-item" },
                                  [
                                    _c(
                                      "router-link",
                                      { attrs: { to: "/mainStoryView" } },
                                      [
                                        _vm._v(
                                          "\n                    Decision Tree\n                  "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("li", { staticClass: "dropdown-item" }, [
                                  _c(
                                    "a",
                                    {
                                      on: {
                                        click: function($event) {
                                          return _vm.goTo("universal")
                                        }
                                      }
                                    },
                                    [_vm._v("Universal Rule")]
                                  )
                                ]),
                                _vm._v(" "),
                                _c("li", { staticClass: "dropdown-item" }, [
                                  _c(
                                    "a",
                                    {
                                      on: {
                                        click: function($event) {
                                          return _vm.goTo("overlay")
                                        }
                                      }
                                    },
                                    [_vm._v("Overlay")]
                                  )
                                ]),
                                _vm._v(" "),
                                _c("li", { staticClass: "dropdown-item" }, [
                                  _c(
                                    "a",
                                    {
                                      on: {
                                        click: function($event) {
                                          return _vm.goTo("settings")
                                        }
                                      }
                                    },
                                    [_vm._v("Settings (Setup)")]
                                  )
                                ]),
                                _vm._v(" "),
                                _c("li", { staticClass: "dropdown-item" }, [
                                  _c(
                                    "a",
                                    {
                                      on: {
                                        click: function($event) {
                                          return _vm.goTo("assets")
                                        }
                                      }
                                    },
                                    [_vm._v("Assets")]
                                  )
                                ]),
                                _vm._v(" "),
                                _c("li", { staticClass: "dropdown-item" }, [
                                  _c(
                                    "a",
                                    {
                                      on: {
                                        click: function($event) {
                                          return _vm.goTo("conversation")
                                        }
                                      }
                                    },
                                    [_vm._v("Conversation")]
                                  )
                                ]),
                                _vm._v(" "),
                                _c("li", { staticClass: "dropdown-item" }, [
                                  _c(
                                    "a",
                                    {
                                      on: {
                                        click: function($event) {
                                          return _vm.goTo("moodboard")
                                        }
                                      }
                                    },
                                    [_vm._v("Moodboard")]
                                  )
                                ])
                              ]
                            )
                          ]
                        )
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _vm.$store.state.user.role == "admin" ||
                  _vm.$store.state.user.role == "developer"
                    ? _c(
                        "li",
                        { staticClass: "nav-item notForMobile" },
                        [
                          _c("router-link", { attrs: { to: "/assets" } }, [
                            _c("span", { staticClass: "nav-menu-icon" }, [
                              _c("img", {
                                attrs: {
                                  src: require("../../assets/icons/assets.svg")
                                }
                              })
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "nav-menu-text" }, [
                              _vm._v("Assets")
                            ])
                          ])
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.$store.state.user.role == "admin" ||
                  _vm.$store.state.user.role == "developer"
                    ? _c(
                        "li",
                        { staticClass: "nav-item notForMobile" },
                        [
                          _c("router-link", { attrs: { to: "/userclass" } }, [
                            _c("span", { staticClass: "nav-menu-icon" }, [
                              _c("img", {
                                attrs: {
                                  src: require("../../assets/icons/api.svg")
                                }
                              })
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "nav-menu-text" }, [
                              _vm._v("API calls")
                            ])
                          ])
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "li",
                    { staticClass: "nav-item" },
                    [
                      _c("router-link", { attrs: { to: "/abxr-market" } }, [
                        _c("span", { staticClass: "nav-menu-icon" }, [
                          _c("img", {
                            attrs: {
                              src: require("../../assets/icons/abxr_market.svg")
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "nav-menu-text" }, [
                          _vm._v("ABXR Market")
                        ])
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.$store.state.user.role == "admin" ||
                  _vm.$store.state.user.role == "developer"
                    ? _c("li", { staticClass: "nav-item" }, [_vm._m(2)])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "li",
                    { staticClass: "nav-item " },
                    [
                      _c("router-link", { attrs: { to: "/legal" } }, [
                        _c("span", { staticClass: "nav-menu-icon" }, [
                          _c("img", {
                            attrs: {
                              src: require("../../assets/icons/legal.svg")
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "nav-menu-text" }, [
                          _vm._v("Legal")
                        ])
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "li",
                    { staticClass: "nav-item " },
                    [
                      _c("router-link", { attrs: { to: "/updates" } }, [
                        _c("span", { staticClass: "nav-menu-icon" }, [
                          _c("img", {
                            attrs: {
                              src: require("../../assets/icons/update.svg")
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "nav-menu-text" }, [
                          _vm._v("Updates")
                        ])
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "li",
                    {
                      staticClass: "nav-item logout",
                      on: { click: _vm.userSignOut }
                    },
                    [_vm._m(3)]
                  )
                ])
              ]
            )
          ])
        ]
      )
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      {
        staticClass: "nav-link dropdown-toggle",
        attrs: {
          id: "dropdowna",
          "data-toggle": "dropdown",
          "aria-haspopup": "true",
          "aria-expanded": "false"
        }
      },
      [
        _c("span", { staticClass: "nav-menu-icon" }, [
          _c("img", { attrs: { src: require("../../assets/icons/user.svg") } })
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "nav-menu-text" }, [_vm._v("User Profile")])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      {
        staticClass: "nav-link dropdown-toggle",
        attrs: {
          id: "dropdown2",
          "data-toggle": "dropdown",
          "aria-haspopup": "true",
          "aria-expanded": "false"
        }
      },
      [
        _c("span", { staticClass: "nav-menu-icon" }, [
          _c("img", {
            attrs: { src: require("../../assets/icons/projects.svg") }
          })
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "nav-menu-text" }, [_vm._v("Projects")])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      {
        attrs: {
          href:
            "https://form.asana.com/?k=sRCquzOsrD80OLXxgsgw7w&d=1132933429989814",
          target: "_"
        }
      },
      [
        _c("span", { staticClass: "nav-menu-icon" }, [
          _c("img", {
            attrs: { src: require("../../assets/icons/support.svg") }
          })
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "nav-menu-text" }, [_vm._v("Support")])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("a", [
      _c("span", { staticClass: "nav-menu-icon" }, [
        _c("i", { staticClass: "fas fa-sign-out-alt" })
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "nav-menu-text" }, [_vm._v("Log out")])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ce9b9fd4", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ce9b9fd4","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/profile/sidebar.vue
// module id = null
// module chunks = 